enum MediaQueriesEnum {
    xs = 300,
    sm = 600,
    md = 900,
    lg = 1200,
    xl = 1500
}

export default MediaQueriesEnum;
